// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_moment_dist_index_js-node_modules_leaflet-defaulticon-compatib-1c7d79":"828fb19b5311c75b2ece","node_modules_moment_locale_sync_recursive_-src_views_PhotosTab_vue":"3dc3d16c389d3663cbd1"}[chunkId] + "";
};